import { useParams } from "react-router-dom";
import EditBookForm from "../components/edit/EditBookForm";
import { useGetBookQuery } from "../features/api/apiSlice";

export default function EditBook() {
	const {bookId} = useParams();
	const { data: book, isLoading, isError, isSuccess } = useGetBookQuery(bookId);
	
	let content = null;

	if (isLoading) {
		content = <div>Loading...</div>;
	}
	else if (!isLoading && isError) {
		content = <div>There was an error</div>;
	}
	else if (isSuccess && book?.id) {
		content = <EditBookForm book={book} />
	}

	return (
		<main className="py-6 2xl:px-6">
			<div className="container">
				<div className="p-8 overflow-hidden bg-white shadow-cardShadow rounded-md max-w-xl mx-auto">
					<h4 className="mb-8 text-xl font-bold text-center">
						Edit Book
					</h4>
					{content}
				</div>
			</div>
		</main>
	);
}
